var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-100 h-100 d-flex calender-top"
  }, [_c('div', {
    staticClass: "left-calender"
  }, [_c('h2', {
    staticClass: "settingmain-side-bar"
  }, [_vm._v("Setting")]), _c('div', {
    staticClass: "wrappercalender scrollow-side"
  }, [_c('div', {
    staticClass: "sidebarhrmcalender"
  }, [_c('ul', {
    staticClass: "hrm-ul-calender-page"
  }, [_c('li', {
    class: `${_vm.selectedTab == 'general' ? 'selected-active' : ''}`,
    on: {
      "click": function ($event) {
        _vm.selectedTab = 'general';
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "headIcon-container"
  }, [_c('vb-icon', {
    staticClass: "svgiconmenu svgicsize",
    attrs: {
      "icon": "general-icon",
      "height": "17.85px",
      "width": "15.06px"
    }
  })], 1), _c('span', {
    staticClass: "setting-sidebar-dropdown"
  }, [_vm._v("General ")])])]), _c('div', [_c('li', {
    class: `${_vm.selectedTab == 'policiestimeoffsetting' ? 'selected-active' : ''}`,
    on: {
      "click": function ($event) {
        _vm.selectedTab = 'policiestimeoffsetting';
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "headIcon-container"
  }, [_c('vb-icon', {
    staticClass: "svgiconmenu svgicsize",
    attrs: {
      "icon": "time-off-icon",
      "height": "20px",
      "width": "20px"
    }
  })], 1), _c('span', {
    staticClass: "setting-sidebar-dropdown"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between w-100 align-items-center"
  }, [_vm._v(" Time off "), _c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.timeoff-1",
      modifiers: {
        "timeoff-1": true
      }
    }],
    staticClass: "togg-btn-report",
    attrs: {
      "variant": "primary"
    }
  }, [_c('div', {
    staticClass: "headIcon-container"
  }, [_c('vb-icon', {
    attrs: {
      "icon": "Icon_ionic-ios-arrow-down",
      "height": "7.719px",
      "width": "13.5px"
    }
  })], 1)])], 1)])])]), _c('b-collapse', {
    staticClass: "w-100",
    attrs: {
      "id": "timeoff-1"
    }
  }, [_c('ul', {
    staticClass: "ul-setting-page"
  }, [_c('li', {
    class: `${_vm.selectedTab == 'policiestimeoffsetting' ? 'selected-active' : ''}`,
    on: {
      "click": function ($event) {
        _vm.selectedTab = 'policiestimeoffsetting';
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Policy")])]), _c('li', {
    class: `${_vm.selectedTab == 'indivisualallowances' ? 'selected-active' : ''}`,
    on: {
      "click": function ($event) {
        _vm.selectedTab = 'indivisualallowances';
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Indivisual allowances")])]), _c('li', {
    class: `${_vm.selectedTab == 'timeoffapproverssetting' ? 'selected-active' : ''}`,
    on: {
      "click": function ($event) {
        _vm.selectedTab = 'timeoffapproverssetting';
      }
    }
  }, [_vm._v("Time off approvers")]), _c('li', [_vm._v("Automated reports")]), _c('li', {
    class: `${_vm.selectedTab == 'remindersettings' ? 'selected-active' : ''}`,
    on: {
      "click": function ($event) {
        _vm.selectedTab = 'remindersettings';
      }
    }
  }, [_vm._v("Reminders")])])])], 1), _c('div', [_c('li', {
    class: `${_vm.selectedTab == 'generalcalender' ? 'selected-active' : ''}`,
    on: {
      "click": function ($event) {
        _vm.selectedTab = 'generalcalender';
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "headIcon-container"
  }, [_c('vb-icon', {
    staticClass: "svgiconmenu svgicsize",
    attrs: {
      "icon": "calendar-icon",
      "height": "16.329px",
      "width": "10.886px"
    }
  })], 1), _c('span', {
    staticClass: "setting-sidebar-dropdown"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between w-100 align-items-center"
  }, [_vm._v(" Calender "), _c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.calender-1",
      modifiers: {
        "calender-1": true
      }
    }],
    staticClass: "togg-btn-report",
    attrs: {
      "variant": "primary"
    }
  }, [_c('svg', {
    staticClass: "svgtoggle svgiconmenu",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "17.46",
      "height": "9.926",
      "viewBox": "0 0 17.46 9.926"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_15893",
      "data-name": "Group 15893",
      "transform": "translate(-54.046 -5.227)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_15891",
      "data-name": "Group 15891",
      "transform": "translate(55.46 6.64)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_41822",
      "data-name": "Path 41822",
      "d": "M13996.459,9709.063l7.113,6.908",
      "transform": "translate(-13996.459 -9709.063)",
      "fill": "none",
      "stroke": "#828282",
      "stroke-linecap": "round",
      "stroke-width": "2"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_41823",
      "data-name": "Path 41823",
      "d": "M14003.77,9709.063l-7.311,7.1",
      "transform": "translate(-13989.138 -9709.063)",
      "fill": "none",
      "stroke": "#828282",
      "stroke-linecap": "round",
      "stroke-width": "2"
    }
  })])])])])], 1)])])]), _c('b-collapse', {
    staticClass: "w-100",
    attrs: {
      "id": "calender-1"
    }
  }, [_c('ul', {
    staticClass: "ul-setting-page"
  }, [_c('li', {
    class: `${_vm.selectedTab == 'generalcalender' ? 'selected-active' : ''}`,
    on: {
      "click": function ($event) {
        _vm.selectedTab = 'generalcalender';
      }
    }
  }, [_vm._v("General")]), _c('li', {
    class: `${_vm.selectedTab == 'publicholidaygroup' ? 'selected-active' : ''}`,
    on: {
      "click": function ($event) {
        _vm.selectedTab = 'publicholidaygroup';
      }
    }
  }, [_vm._v("Public holidays groups")]), _c('li', {
    class: `${_vm.selectedTab == 'publicholiday' ? 'selected-active' : ''}`,
    on: {
      "click": function ($event) {
        _vm.selectedTab = 'publicholiday';
      }
    }
  }, [_vm._v("Public holidays")]), _c('li', {
    class: `${_vm.selectedTab == 'customworkingdays' ? 'selected-active' : ''}`,
    on: {
      "click": function ($event) {
        _vm.selectedTab = 'customworkingdays';
      }
    }
  }, [_vm._v("Custom working days")]), _c('li', {
    class: `${_vm.selectedTab == 'blackoutdates' ? 'selected-active' : ''}`,
    on: {
      "click": function ($event) {
        _vm.selectedTab = 'blackoutdates';
      }
    }
  }, [_vm._v("Blackout dates")])])])], 1), _c('li', {
    class: `${_vm.selectedTab == 'calendar' ? 'selected-active' : ''}`,
    on: {
      "click": function ($event) {
        _vm.selectedTab = 'calendar';
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "headIcon-container"
  }, [_c('vb-icon', {
    staticClass: "svgiconmenu svgicsize",
    attrs: {
      "icon": "calendar-icon",
      "height": "16.329px",
      "width": "10.886px"
    }
  })], 1), _c('span', {
    staticClass: "setting-sidebar-dropdown"
  }, [_vm._v("Calender "), _c('div', {
    staticClass: "headIcon-container"
  }, [_c('vb-icon', {
    attrs: {
      "icon": "Icon_ionic-ios-arrow-down",
      "height": "7.719px",
      "width": "13.5px"
    }
  })], 1)])])]), _c('li', {
    class: `${_vm.selectedTab == 'notes' ? 'selected-active' : ''}`,
    on: {
      "click": function ($event) {
        _vm.selectedTab = 'notes';
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "headIcon-container"
  }, [_c('vb-icon', {
    staticClass: "svgiconmenu svgicsize",
    attrs: {
      "icon": "announcement-icon",
      "height": "17.536px",
      "width": "14.088px"
    }
  })], 1), _c('span', {
    staticClass: "setting-sidebar-dropdown"
  }, [_vm._v("Announcement "), _c('div', {
    staticClass: "headIcon-container"
  }, [_c('vb-icon', {
    attrs: {
      "icon": "Icon_ionic-ios-arrow-down",
      "height": "7.719px",
      "width": "13.5px"
    }
  })], 1)])])]), _c('li', {
    class: `${_vm.selectedTab == 'permissions' ? 'selected-active' : ''}`,
    on: {
      "click": function ($event) {
        _vm.selectedTab = 'permissions';
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('svg', {
    staticClass: "svgiconmenu svgicsize",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14.101",
      "height": "17",
      "viewBox": "0 0 14.101 17"
    }
  }, [_c('path', {
    attrs: {
      "id": "Union_66",
      "data-name": "Union 66",
      "d": "M2160.579-21067c-.1-.047-.206-.078-.3-.131a.851.851,0,0,1-.423-.689c-.005-.158,0-.316,0-.492h8.418a1.382,1.382,0,0,0,1.328-.787,1.568,1.568,0,0,0,.137-.73v-11.377a4.677,4.677,0,0,1,.736.07.857.857,0,0,1,.619.9v12.217a.925.925,0,0,1-.36.83,2.573,2.573,0,0,1-.376.186Zm-1.6-1.814a.886.886,0,0,1-.942-.662,1.438,1.438,0,0,1-.032-.338q-.008-4.477-.005-8.953v-.18h2.709a1.257,1.257,0,0,0,1.344-1.35c0-.824,0-1.645-.005-2.471v-.232h6.207a.894.894,0,0,1,.989.984v12.217a.892.892,0,0,1-.989.984Zm1.757-3.83a.575.575,0,0,0-.333.152.344.344,0,0,0-.069.418.428.428,0,0,0,.413.26h3.027a.421.421,0,0,0,.444-.424.415.415,0,0,0-.434-.412q-.631,0-1.262,0C2161.923-21072.652,2161.328-21072.65,2160.733-21072.643Zm-.074-2.133a.41.41,0,0,0-.281.65.467.467,0,0,0,.423.18h5.968a.991.991,0,0,0,.217-.016.408.408,0,0,0,.238-.641.448.448,0,0,0-.4-.18h-6.058A.7.7,0,0,0,2160.659-21074.775Zm-.011-2.26a.405.405,0,0,0-.28.631.463.463,0,0,0,.418.2c1.005-.006,2.01-.006,3.01-.006h2.72c.137,0,.27.006.407,0a.4.4,0,0,0,.349-.254.386.386,0,0,0-.048-.4.5.5,0,0,0-.455-.18h-5.937A1.212,1.212,0,0,0,2160.648-21077.035Zm-2.212-2.412a.382.382,0,0,1-.4-.244.387.387,0,0,1,.122-.434l2.709-2.709a.387.387,0,0,1,.45-.117.391.391,0,0,1,.228.408c-.005.387,0,.777,0,1.17v1.121a.746.746,0,0,1-.783.8c-.259,0-.518,0-.776,0Z",
      "transform": "translate(-2157.497 21083.498)",
      "fill": "#5b5b5b",
      "stroke": "rgba(0,0,0,0)",
      "stroke-miterlimit": "10",
      "stroke-width": "1"
    }
  })]), _c('div', {
    staticClass: "headIcon-container"
  }, [_c('vb-icon', {
    attrs: {
      "icon": "announcement-icon",
      "height": "17px",
      "width": "14.101px"
    }
  })], 1), _c('span', {
    staticClass: "setting-sidebar-dropdown"
  }, [_vm._v("Permissions "), _c('svg', {
    staticClass: "svgiconmenu",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "13.5",
      "height": "7.719",
      "viewBox": "0 0 13.5 7.719"
    }
  }, [_c('path', {
    attrs: {
      "id": "Icon_ionic-ios-arrow-down",
      "data-name": "Icon ionic-ios-arrow-down",
      "d": "M12.94,16.638l5.1-5.109a.961.961,0,0,1,1.363,0,.973.973,0,0,1,0,1.367l-5.784,5.788a.963.963,0,0,1-1.33.028L6.469,12.9a.965.965,0,0,1,1.363-1.367Z",
      "transform": "translate(-6.188 -11.246)",
      "fill": "#5b5b5b"
    }
  })])])])]), _c('li', {
    class: `${_vm.selectedTab == 'employeedata' ? 'selected-active' : ''}`,
    on: {
      "click": function ($event) {
        _vm.selectedTab = 'employeedata';
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('svg', {
    staticClass: "svgiconmenu svgicsize",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14.101",
      "height": "17",
      "viewBox": "0 0 14.101 17"
    }
  }, [_c('path', {
    attrs: {
      "id": "Union_66",
      "data-name": "Union 66",
      "d": "M2160.579-21067c-.1-.047-.206-.078-.3-.131a.851.851,0,0,1-.423-.689c-.005-.158,0-.316,0-.492h8.418a1.382,1.382,0,0,0,1.328-.787,1.568,1.568,0,0,0,.137-.73v-11.377a4.677,4.677,0,0,1,.736.07.857.857,0,0,1,.619.9v12.217a.925.925,0,0,1-.36.83,2.573,2.573,0,0,1-.376.186Zm-1.6-1.814a.886.886,0,0,1-.942-.662,1.438,1.438,0,0,1-.032-.338q-.008-4.477-.005-8.953v-.18h2.709a1.257,1.257,0,0,0,1.344-1.35c0-.824,0-1.645-.005-2.471v-.232h6.207a.894.894,0,0,1,.989.984v12.217a.892.892,0,0,1-.989.984Zm1.757-3.83a.575.575,0,0,0-.333.152.344.344,0,0,0-.069.418.428.428,0,0,0,.413.26h3.027a.421.421,0,0,0,.444-.424.415.415,0,0,0-.434-.412q-.631,0-1.262,0C2161.923-21072.652,2161.328-21072.65,2160.733-21072.643Zm-.074-2.133a.41.41,0,0,0-.281.65.467.467,0,0,0,.423.18h5.968a.991.991,0,0,0,.217-.016.408.408,0,0,0,.238-.641.448.448,0,0,0-.4-.18h-6.058A.7.7,0,0,0,2160.659-21074.775Zm-.011-2.26a.405.405,0,0,0-.28.631.463.463,0,0,0,.418.2c1.005-.006,2.01-.006,3.01-.006h2.72c.137,0,.27.006.407,0a.4.4,0,0,0,.349-.254.386.386,0,0,0-.048-.4.5.5,0,0,0-.455-.18h-5.937A1.212,1.212,0,0,0,2160.648-21077.035Zm-2.212-2.412a.382.382,0,0,1-.4-.244.387.387,0,0,1,.122-.434l2.709-2.709a.387.387,0,0,1,.45-.117.391.391,0,0,1,.228.408c-.005.387,0,.777,0,1.17v1.121a.746.746,0,0,1-.783.8c-.259,0-.518,0-.776,0Z",
      "transform": "translate(-2157.497 21083.498)",
      "fill": "#5b5b5b",
      "stroke": "rgba(0,0,0,0)",
      "stroke-miterlimit": "10",
      "stroke-width": "1"
    }
  })]), _c('span', {
    staticClass: "setting-sidebar-dropdown"
  }, [_vm._v("Employee data "), _c('svg', {
    staticClass: "svgiconmenu",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "13.5",
      "height": "7.719",
      "viewBox": "0 0 13.5 7.719"
    }
  }, [_c('path', {
    attrs: {
      "id": "Icon_ionic-ios-arrow-down",
      "data-name": "Icon ionic-ios-arrow-down",
      "d": "M12.94,16.638l5.1-5.109a.961.961,0,0,1,1.363,0,.973.973,0,0,1,0,1.367l-5.784,5.788a.963.963,0,0,1-1.33.028L6.469,12.9a.965.965,0,0,1,1.363-1.367Z",
      "transform": "translate(-6.188 -11.246)",
      "fill": "#5b5b5b"
    }
  })])])])]), _c('li', {
    class: `${_vm.selectedTab == 'asset' ? 'selected-active' : ''}`,
    on: {
      "click": function ($event) {
        _vm.selectedTab = 'asset';
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('svg', {
    staticClass: "svgiconmenu svgicsize",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16.004",
      "height": "12.803",
      "viewBox": "0 0 16.004 12.803"
    }
  }, [_c('path', {
    attrs: {
      "id": "Icon_awesome-tags",
      "data-name": "Icon awesome-tags",
      "d": "M12.452,5.65l-5.3-5.3A1.2,1.2,0,0,0,6.3,0H1.2A1.2,1.2,0,0,0,0,1.2V6.3a1.2,1.2,0,0,0,.352.849l5.3,5.3a1.2,1.2,0,0,0,1.7,0l5.1-5.1A1.2,1.2,0,0,0,12.452,5.65ZM2.8,4A1.2,1.2,0,1,1,4,2.8,1.2,1.2,0,0,1,2.8,4ZM15.652,7.347l-5.1,5.1a1.2,1.2,0,0,1-1.7,0l-.009-.009L13.194,8.09a2.251,2.251,0,0,0,0-3.183L8.287,0H9.505a1.2,1.2,0,0,1,.849.352l5.3,5.3a1.2,1.2,0,0,1,0,1.7Z",
      "fill": "#5b5b5b"
    }
  })]), _c('span', {
    staticClass: "setting-sidebar-dropdown"
  }, [_vm._v("Assets "), _c('svg', {
    staticClass: "svgiconmenu",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "13.5",
      "height": "7.719",
      "viewBox": "0 0 13.5 7.719"
    }
  }, [_c('path', {
    attrs: {
      "id": "Icon_ionic-ios-arrow-down",
      "data-name": "Icon ionic-ios-arrow-down",
      "d": "M12.94,16.638l5.1-5.109a.961.961,0,0,1,1.363,0,.973.973,0,0,1,0,1.367l-5.784,5.788a.963.963,0,0,1-1.33.028L6.469,12.9a.965.965,0,0,1,1.363-1.367Z",
      "transform": "translate(-6.188 -11.246)",
      "fill": "#5b5b5b"
    }
  })])])])]), _c('li', {
    class: `${_vm.selectedTab == 'onboarding' ? 'selected-active' : ''}`,
    on: {
      "click": function ($event) {
        _vm.selectedTab = 'onboarding';
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('svg', {
    staticClass: "svgiconmenu",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "22",
      "height": "22",
      "viewBox": "0 0 17.036 15.047"
    }
  }, [_c('path', {
    attrs: {
      "id": "onboard",
      "d": "M7.013,13.643a.64.64,0,0,1,.076-.731,3.341,3.341,0,0,1,.461-.463.7.7,0,0,1,.97.985,2.954,2.954,0,0,1-.454.446,1.442,1.442,0,0,1-.346.161A.737.737,0,0,1,7.013,13.643ZM4.687,12.632a.627.627,0,0,1,.094-.729c.356-.38.724-.751,1.105-1.1a.694.694,0,0,1,.978.973c-.357.386-.733.756-1.117,1.113a1.036,1.036,0,0,1-.346.159A.719.719,0,0,1,4.687,12.632Zm5.093-.14c-.2-.194-.391-.389-.584-.586a1.606,1.606,0,0,0-1.129-.528c-.082,0-.12-.03-.126-.117A1.562,1.562,0,0,0,6.836,9.8.256.256,0,0,1,6.8,9.78a.1.1,0,0,1-.012-.017,1.641,1.641,0,0,0-2.2-2.2,1.676,1.676,0,0,0-2.906-.538c-.048-.138-.093-.259-.131-.382A2.538,2.538,0,0,0,.894,5.592C.65,5.351.41,5.105.172,4.858a.469.469,0,0,1,0-.728Q2.129,2.173,4.086.219A.463.463,0,0,1,4.791.2c.373.369.741.746,1.111,1.12.022.022.043.045.077.08-.04.042-.077.083-.116.122-.5.5-1,.993-1.49,1.492A1.387,1.387,0,0,0,4.134,4.8a1.984,1.984,0,0,0,1.26.859A2.291,2.291,0,0,0,7.582,5.1a.489.489,0,0,1,.767-.012,2.334,2.334,0,0,0,2.83.3c.022-.013.044-.024.07-.039.027.023.051.041.073.063q1.37,1.369,2.74,2.74A.7.7,0,1,1,13.1,9.178c-.37-.358-.728-.73-1.1-1.089a.718.718,0,0,0-.286-.175.44.44,0,0,0-.5.223.456.456,0,0,0,.081.56c.305.314.616.62.926.93.077.077.157.153.23.234a.7.7,0,1,1-1,.985c-.374-.362-.735-.737-1.11-1.1a.716.716,0,0,0-.286-.175.44.44,0,0,0-.495.211.455.455,0,0,0,.055.551c.154.168.32.327.481.49.235.237.475.467.7.71a.7.7,0,0,1-.456,1.175q-.034,0-.067,0A.7.7,0,0,1,9.78,12.491ZM3.029,10.977a.642.642,0,0,1,.1-.741c.256-.28.531-.543.8-.812.3-.305.607-.615.919-.912a.649.649,0,0,1,.724-.137.668.668,0,0,1,.444.589.6.6,0,0,1-.158.5c-.58.589-1.162,1.176-1.757,1.75a1.071,1.071,0,0,1-.356.169A.724.724,0,0,1,3.029,10.977Zm-1.3-1.31a.7.7,0,0,1-.208-1.141c.325-.329.648-.661.982-.981a.7.7,0,1,1,.985,1q-.483.5-.982.98a.682.682,0,0,1-.48.211A.744.744,0,0,1,1.725,9.666ZM11.32,4.031c-.076.071-.119.109-.159.148a1.677,1.677,0,0,1-1.84.336,4.132,4.132,0,0,1-.63-.338,1.392,1.392,0,0,0-1.6.12,1.9,1.9,0,0,1-.708.441,1.39,1.39,0,0,1-1.383-.352.449.449,0,0,1,0-.669c.246-.255.5-.5.75-.752.407-.4.809-.812,1.223-1.207A1.356,1.356,0,0,1,7.945,1.4h.5c.337,0,.673,0,1.011,0a1.1,1.1,0,0,0,.851-.352c.276-.29.565-.569.85-.852a.482.482,0,0,1,.782,0Q13.873,2.125,15.8,4.056a2.013,2.013,0,0,1,.2.29v.219a3.77,3.77,0,0,1-.265.339c-.308.319-.625.627-.937.941a1.047,1.047,0,0,0-.285.947c.022.146.019.3.029.463Z",
      "transform": "translate(0.534 0.5)",
      "fill": "#5b5b5b",
      "stroke": "rgba(0,0,0,0)",
      "stroke-miterlimit": "10",
      "stroke-width": "1"
    }
  })]), _c('span', {
    staticClass: "setting-sidebar-dropdown"
  }, [_vm._v("Onboarding "), _c('svg', {
    staticClass: "svgiconmenu",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "13.5",
      "height": "7.719",
      "viewBox": "0 0 13.5 7.719"
    }
  }, [_c('path', {
    attrs: {
      "id": "Icon_ionic-ios-arrow-down",
      "data-name": "Icon ionic-ios-arrow-down",
      "d": "M12.94,16.638l5.1-5.109a.961.961,0,0,1,1.363,0,.973.973,0,0,1,0,1.367l-5.784,5.788a.963.963,0,0,1-1.33.028L6.469,12.9a.965.965,0,0,1,1.363-1.367Z",
      "transform": "translate(-6.188 -11.246)",
      "fill": "#5b5b5b"
    }
  })])])])]), _c('li', {
    class: `${_vm.selectedTab == 'offboarding' ? 'selected-active' : ''}`,
    on: {
      "click": function ($event) {
        _vm.selectedTab = 'offboarding';
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('svg', {
    staticClass: "svgiconmenu",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "22",
      "height": "22",
      "viewBox": "0 0 17.036 15.047"
    }
  }, [_c('path', {
    attrs: {
      "id": "onboard",
      "d": "M7.013,13.643a.64.64,0,0,1,.076-.731,3.341,3.341,0,0,1,.461-.463.7.7,0,0,1,.97.985,2.954,2.954,0,0,1-.454.446,1.442,1.442,0,0,1-.346.161A.737.737,0,0,1,7.013,13.643ZM4.687,12.632a.627.627,0,0,1,.094-.729c.356-.38.724-.751,1.105-1.1a.694.694,0,0,1,.978.973c-.357.386-.733.756-1.117,1.113a1.036,1.036,0,0,1-.346.159A.719.719,0,0,1,4.687,12.632Zm5.093-.14c-.2-.194-.391-.389-.584-.586a1.606,1.606,0,0,0-1.129-.528c-.082,0-.12-.03-.126-.117A1.562,1.562,0,0,0,6.836,9.8.256.256,0,0,1,6.8,9.78a.1.1,0,0,1-.012-.017,1.641,1.641,0,0,0-2.2-2.2,1.676,1.676,0,0,0-2.906-.538c-.048-.138-.093-.259-.131-.382A2.538,2.538,0,0,0,.894,5.592C.65,5.351.41,5.105.172,4.858a.469.469,0,0,1,0-.728Q2.129,2.173,4.086.219A.463.463,0,0,1,4.791.2c.373.369.741.746,1.111,1.12.022.022.043.045.077.08-.04.042-.077.083-.116.122-.5.5-1,.993-1.49,1.492A1.387,1.387,0,0,0,4.134,4.8a1.984,1.984,0,0,0,1.26.859A2.291,2.291,0,0,0,7.582,5.1a.489.489,0,0,1,.767-.012,2.334,2.334,0,0,0,2.83.3c.022-.013.044-.024.07-.039.027.023.051.041.073.063q1.37,1.369,2.74,2.74A.7.7,0,1,1,13.1,9.178c-.37-.358-.728-.73-1.1-1.089a.718.718,0,0,0-.286-.175.44.44,0,0,0-.5.223.456.456,0,0,0,.081.56c.305.314.616.62.926.93.077.077.157.153.23.234a.7.7,0,1,1-1,.985c-.374-.362-.735-.737-1.11-1.1a.716.716,0,0,0-.286-.175.44.44,0,0,0-.495.211.455.455,0,0,0,.055.551c.154.168.32.327.481.49.235.237.475.467.7.71a.7.7,0,0,1-.456,1.175q-.034,0-.067,0A.7.7,0,0,1,9.78,12.491ZM3.029,10.977a.642.642,0,0,1,.1-.741c.256-.28.531-.543.8-.812.3-.305.607-.615.919-.912a.649.649,0,0,1,.724-.137.668.668,0,0,1,.444.589.6.6,0,0,1-.158.5c-.58.589-1.162,1.176-1.757,1.75a1.071,1.071,0,0,1-.356.169A.724.724,0,0,1,3.029,10.977Zm-1.3-1.31a.7.7,0,0,1-.208-1.141c.325-.329.648-.661.982-.981a.7.7,0,1,1,.985,1q-.483.5-.982.98a.682.682,0,0,1-.48.211A.744.744,0,0,1,1.725,9.666ZM11.32,4.031c-.076.071-.119.109-.159.148a1.677,1.677,0,0,1-1.84.336,4.132,4.132,0,0,1-.63-.338,1.392,1.392,0,0,0-1.6.12,1.9,1.9,0,0,1-.708.441,1.39,1.39,0,0,1-1.383-.352.449.449,0,0,1,0-.669c.246-.255.5-.5.75-.752.407-.4.809-.812,1.223-1.207A1.356,1.356,0,0,1,7.945,1.4h.5c.337,0,.673,0,1.011,0a1.1,1.1,0,0,0,.851-.352c.276-.29.565-.569.85-.852a.482.482,0,0,1,.782,0Q13.873,2.125,15.8,4.056a2.013,2.013,0,0,1,.2.29v.219a3.77,3.77,0,0,1-.265.339c-.308.319-.625.627-.937.941a1.047,1.047,0,0,0-.285.947c.022.146.019.3.029.463Z",
      "transform": "translate(0.534 0.5)",
      "fill": "#5b5b5b",
      "stroke": "rgba(0,0,0,0)",
      "stroke-miterlimit": "10",
      "stroke-width": "1"
    }
  })]), _c('span', {
    staticClass: "setting-sidebar-dropdown"
  }, [_vm._v("Offboarding "), _c('svg', {
    staticClass: "svgiconmenu",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "13.5",
      "height": "7.719",
      "viewBox": "0 0 13.5 7.719"
    }
  }, [_c('path', {
    attrs: {
      "id": "Icon_ionic-ios-arrow-down",
      "data-name": "Icon ionic-ios-arrow-down",
      "d": "M12.94,16.638l5.1-5.109a.961.961,0,0,1,1.363,0,.973.973,0,0,1,0,1.367l-5.784,5.788a.963.963,0,0,1-1.33.028L6.469,12.9a.965.965,0,0,1,1.363-1.367Z",
      "transform": "translate(-6.188 -11.246)",
      "fill": "#5b5b5b"
    }
  })])])])]), _c('div', [_c('li', {
    class: `${_vm.selectedTab == 'settingsbilling' ? 'selected-active' : ''}`,
    on: {
      "click": function ($event) {
        _vm.selectedTab = 'settingsbilling';
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('svg', {
    staticClass: "svgiconmenu",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "20",
      "height": "20",
      "viewBox": "0 0 16.133 15.184"
    }
  }, [_c('path', {
    attrs: {
      "id": "Reports",
      "d": "M15.652,8.541H8.615L13.3,13.227a.476.476,0,0,0,.658.02A7.1,7.1,0,0,0,16.128,9.07a.475.475,0,0,0-.476-.529Zm-.469-1.922A7.134,7.134,0,0,0,8.564,0a.477.477,0,0,0-.5.48V7.117H14.7A.477.477,0,0,0,15.182,6.619ZM6.643,8.541V1.5a.475.475,0,0,0-.529-.476A7.112,7.112,0,0,0,0,8.315a7.205,7.205,0,0,0,7.2,6.869,7.062,7.062,0,0,0,4.011-1.306.471.471,0,0,0,.047-.714Z",
      "transform": "translate(0 0)",
      "fill": "#5b5b5b"
    }
  })]), _c('span', {
    staticClass: "setting-sidebar-dropdown"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between w-100 align-items-center"
  }, [_vm._v(" Billings "), _c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.holidnl-1",
      modifiers: {
        "holidnl-1": true
      }
    }],
    staticClass: "togg-btn-report",
    attrs: {
      "variant": "primary"
    }
  }, [_c('svg', {
    staticClass: "svgtoggle svgiconmenu",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "17.46",
      "height": "9.926",
      "viewBox": "0 0 17.46 9.926"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_15893",
      "data-name": "Group 15893",
      "transform": "translate(-54.046 -5.227)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_15891",
      "data-name": "Group 15891",
      "transform": "translate(55.46 6.64)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_41822",
      "data-name": "Path 41822",
      "d": "M13996.459,9709.063l7.113,6.908",
      "transform": "translate(-13996.459 -9709.063)",
      "fill": "none",
      "stroke": "#828282",
      "stroke-linecap": "round",
      "stroke-width": "2"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_41823",
      "data-name": "Path 41823",
      "d": "M14003.77,9709.063l-7.311,7.1",
      "transform": "translate(-13989.138 -9709.063)",
      "fill": "none",
      "stroke": "#828282",
      "stroke-linecap": "round",
      "stroke-width": "2"
    }
  })])])])])], 1)])])]), _c('b-collapse', {
    staticClass: "w-100",
    attrs: {
      "id": "holidnl-1"
    }
  }, [_c('ul', {
    staticClass: "ul-setting-page"
  }, [_c('li', {
    staticClass: "sideBarlist-dropdownNav"
  }, [_vm._v("Policy")]), _c('li', [_vm._v("Indivisual allowances")]), _c('li', [_vm._v("Time off approvers")]), _c('li', [_vm._v("Automated reports")]), _c('li', [_vm._v("Reminders")])])])], 1)])])])]), _vm.selectedTab == 'calendar' ? _c('calendar', {
    attrs: {
      "data": _vm.calendarData
    }
  }) : _vm._e(), _vm.selectedTab == 'general' ? _c('GeneralSettingHRM') : _vm._e(), _vm.selectedTab == 'policiestimeoffsetting' ? _c('PoliciesTimeoffSettingHRM') : _vm._e(), _vm.selectedTab == 'indivisualallowances' ? _c('IndivisualAllowancesSettingHRM') : _vm._e(), _vm.selectedTab == 'timeoffapproverssetting' ? _c('TimeoffApproversSettingHRM') : _vm._e(), _vm.selectedTab == 'remindersettings' ? _c('TimeoffRemainderSettingHRM') : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }